import { RequestBasePageId, ResponseBaseSet } from "@myapp/modules/fwcore/models/messages";
import { LogCategory } from "../log-category";

export class RequestLogCategory extends RequestBasePageId{

}

export class ResponseLogCategory extends ResponseBaseSet<LogCategory>{

}


